/**
 * Comma separated list of common focusable selectors.
 *
 * @public
 */

export const FOCUSABLE_SELECTORS =
  'a[href], button:not([disabled]), details, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
